var map = {
	"./company.svg": "bb74",
	"./debug.log": "74ec",
	"./deposit.svg": "5086",
	"./icon-arrow-right.svg": "9efc",
	"./icon-login-key.svg": "9604",
	"./icon-login-profile.svg": "4b11",
	"./icon-note.svg": "83a4",
	"./icon-otp.svg": "7524",
	"./icon-shield-black.svg": "ffaf",
	"./icon-user-black.svg": "2d3f",
	"./login-bg.svg": "e9bb",
	"./login-rafiki.svg": "87e7",
	"./profile-user.svg": "778e",
	"./pt.svg": "17bb",
	"./pt_manage.svg": "24bf",
	"./searchicon.png": "4428",
	"./setting.svg": "6d1e",
	"./smile.svg": "ee60",
	"./summary.svg": "7710",
	"./summary_white.svg": "d552",
	"./withdraw.svg": "9bee"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";